import { CAProvinces, usStates } from "./util";

export const checkCountryStateMapping = (country, state) => {
  if (country == "CA" && state) {
    if (!CAProvinces.includes(state.toUpperCase())) {
      return true;
    }
  } else if ((country == "US" || country == "USA") && state) {
    if (!!usStates && !usStates.includes(state.toUpperCase())) {
      return true;
    }
  }
};
